export const validation = {
  email: 'required|email',
  first_name: 'required|min:3|max:50',
  middle_name: 'min:3|max:50',
  last_name: 'required|min:3|max:50',
  second_last_name: 'min:3|max:50',
  phone: 'min:10|numeric',
  phone_verified: '',
  email_verified: '',
  status_id: 'required|numeric|min_value:1|max:1',
  role_id: 'required|numeric|min_value:1|max:1',
  password: 'min:6',
  confirm_password: 'confirmed:password',
  facebook_id: 'numeric|min:6',
  gender_id: 'numeric|min_value:1|max_value:2',
  dob: 'date_format',
  country_id: 'numeric|max:11|min_value:1',
  city: 'alpha_spaces|min:3|max:75',
  address2: 'alpha_spaces|min:3|max:75',
  address1: 'alpha_spaces|min:3|max:75',
  zip_code: 'numeric|min:5|max:5'
}

export const CustomerFields = function () {
  return {
    email: null,
    first_name: null,
    middle_name: null,
    last_name: null,
    second_last_name: null,
    phone: null,
    phone_verified: null,
    email_verified: null,
    facebook_id: null,
    password: null,
    confirm_password: null,
    status_id: null,
    role_id: null,
    gender_id: null,
    dob: null,
    country_id: null,
    city: null,
    address2: null,
    address1: null,
    zip_code: null
  }
}

export const statusList = [
  {
    id: 1,
    name: 'Activo'
  },
  {
    id: 2,
    name: 'Inactivo'
  }
]

export const genders = [
  {
    id: 1,
    name_es: 'Femenino',
    name_en: 'Female',
    code: 'F'
  },
  {
    id: 2,
    name_es: 'Masculino',
    name_en: 'Male',
    code: 'M'
  }
]

export const texts = {
  customerEdit: {
    title: 'Editar Cliente Existente',
    subtitle: 'Edita la información del cliente, cambia contraseñas, correo, nombre y más',
    submit: 'Actualizar Cliente',
    messages: {
      success: {
        title: 'CLIENTE ACTUALIZADO',
        text: 'Este cliente ha sido actualizado correctamente'
      }
    }
  },
  customerNew: {
    title: 'Añadir Nuevo Cliente',
    subtitle: 'Crear nuevos clientes de la página web, estos tambien puede registrarse por medio de Facebook y un formulario personalizado',
    submit: 'Crear Cliente',
    messages: {
      success: {
        title: 'CLIENTE CREADO',
        text: 'Se ha creado correctamente el nuevo cliente'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/customers/mocks.js